<template>
	<button
			:class="['iconBtn', customClass]"
			:disabled="isDisabled"
			@click="onClick">
		<svg-sprite v-if="iconAttrs" v-bind="iconAttrs"></svg-sprite>
		<span class="counter" v-if="shouldDisplayCounter">{{ counter }}</span>
	</button>
</template>

<script>
export default {
	name: "iconBtn",
	props: {
		customClass: String,
		isDisabled: Boolean,
		iconAttrs: Object,
		counter: String,
	},
	computed: {
		shouldDisplayCounter() {
			return this.counter !== undefined && this.counter !== null && this.counter !== "" && this.counter !== "0";
		}
	},
	methods: {
		onClick() {
			this.$emit('updateEvent');
		}
	}
};
</script>

<style scoped lang="scss">
.iconBtn {
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
	svg {
		display: block;
	}
	.counter {
		position: absolute;
		top: -3px;
		right: -6px;
		background: red;
		color: #fff;
		border-radius: 50%;
		font-size: 10px;
		text-align: center;
		min-width: 13px;
		height: 13px;
		padding: 1px;
		line-height: 1;
	}
}
</style>
